import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    backgroundImage = "backgroundImage",
    title = "title",
    titleImage = "titleImage",
    subHeading = "subHeading",
    description = "description",
    isEnabledValue = "isEnabledValue"
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundImage]: string;
        [fields.title]: string;
        [fields.titleImage]: string;
        [fields.subHeading]: string;
        [fields.description]: string;
        [fields.isEnabledValue]: boolean
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    currentUserIsGuest: getCurrentUserIsGuest(state),
    userName: state.context.session.userName,
    isSignInPage: getCurrentPage(state).type === "SignInPage",
});
type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface GaiaSignInPopUpStyles {
    mainContainer?: InjectableCss;
    container?: InjectableCss;
    mainImage?: InjectableCss;
    image?: LazyImageProps;
    mainContent?: InjectableCss;
    imageContent?: InjectableCss;
    heading?: TypographyProps;
    subHeading?: TypographyProps;
    description?: TypographyProps;
    signInbuttonWrapper?: ButtonProps;
    linkWrapper?: LinkProps;
    certificateModal?: ModalPresentationProps;
}


export const partNumberStyles: GaiaSignInPopUpStyles = {
    mainContainer: {
        css: css`
            max-width: 837px;
            max-height: 491px;
            width: 100%;
            margin: 0 auto;          
        `,
    },
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    mainImage: {
        css: css`
            width: 326px;
            background: rebeccapurple;
          
        `,
    },
    mainContent: {
        css: css`
            width: 511px;
            padding: 92.48px 74px 69.37px;
            text-align: center;
        `,
    },
    imageContent: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 45px;
        `,
    },
    heading: {
        css: css`
            color: ${getColor("success")};
            font-size: 28px;
            margin-left: 8px;
            font-family: LibreBaskervilleBold;
        `,
    },
    subHeading: {
        css: css`
            color: ${getColor("secondary.contrast")};
            margin-bottom: 14px;
            font-size: 23px;
            font-family: LibreBaskervilleBold;
        `,
    },
    description: {
        css: css`
            margin-bottom: 37px;
            font-size: 14px;
            font-family: Lato;
        `,
    },
    signInbuttonWrapper: {
        css: css`
            margin-bottom: 21px;
        `,
    },
    linkWrapper: {
        css: css`
            font-size: 16px;
            font-family: LatoBold;
        `,
    },
    certificateModal: {
        size: 837,
        cssOverrides: {
            modalTitle: css`
            border-bottom: 0 !important;
            padding: 0 !important;
            position: absolute !important;
            right: 9px !important;
            top: 9px !important     
            `,
            headlineTypography: css`
                font-size: 22px;
                color: ${getColor("primary")};
                margin-bottom: 0;
            `,
            modalContent: css`
                padding: 0px;
                margin: 0px;
                overflow-y: hidden !important;
            `,
        },
    },
};

const styles = partNumberStyles;

const GaiaSignInPopUp: React.FC<Props> = ({ fields, id, userName, currentUserIsGuest, isSignInPage, history }: Props) => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    React.useEffect(() => {
       if(fields.isEnabledValue) {
        const isSignIn = window.localStorage.getItem('is-sign-in')
        setTimeout(() => {
            if (currentUserIsGuest && userName != null) {
                setModalIsOpen(false);
            } else if (userName == null && !isSignInPage && !isSignIn) {
                setModalIsOpen(true);
            }
        }, 3000);
       }
       
    }, []);
    const handleCloseModal = () => {
        setModalIsOpen(false);
        window.localStorage.setItem("is-sign-in", 'true');
    };

    const onClickSignIn = () => {
        history.push("/SignIn");
        handleCloseModal();
    }

    const backgroundStyles = `
                    width: 326px;
                    max-height: 491px;
                    background: rebeccapurple;
                    background-image: url(${fields.backgroundImage});
                    background-size: cover;`;

    const wrapperStyles = {
        css: css`
        ${backgroundStyles};
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        display:none
                        `,
                        css`
                        `,
                        css`
                        
                         `,
                        css`
                        
                        `,
                        css`
                            
                        `,
                    ],
                    "max",
                )}
    `,
    };

    return (
        <>
            <Modal
                {...styles.certificateModal}
                isOpen={modalIsOpen}
                handleClose={handleCloseModal}
            >
                <StyledWrapper {...styles.mainContainer}>
                    <StyledWrapper {...styles.container}>
                        <StyledWrapper {...wrapperStyles} />
                        <StyledWrapper {...styles.mainContent}>
                            <StyledWrapper {...styles.imageContent}>
                                <LazyImage src={fields.titleImage} altText="Icon" />
                                <Typography as="p" {...styles.heading}>
                                    {fields.title}
                                </Typography>
                            </StyledWrapper>
                            <Typography as="p" {...styles.subHeading}>
                                {fields.subHeading}
                            </Typography>
                            <Typography as="p" {...styles.description}>
                                {fields.description}
                            </Typography>
                            <Button onClick={() => onClickSignIn()} {...styles.signInbuttonWrapper}>sign in</Button>
                            <StyledWrapper>
                                <Link onClick={handleCloseModal} {...styles.linkWrapper}>No Thanks!</Link>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(GaiaSignInPopUp)),
    definition: {
        displayName: "GaiaSignInPopUp",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.backgroundImage,
                displayName: "Background Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },

            {
                fieldType: "General",
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.titleImage,
                displayName: "Title Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.subHeading,
                displayName: "SubHeading",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.description,
                displayName: "Description",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.isEnabledValue,
                displayName: "Is pop up shown",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
